import { SceneLighting } from "../common";
import { easeInCubic } from "../interpolation";
import { PieceFn } from "../PieceFn";
import { createScene } from "../sequencer";

const SCENE_OUTRO = 6;

export const defaultLighting: SceneLighting = {
  ambient: [0.2, 0.2, 0.2],
  light1: {
    position: [0, 0, 0],
    intensity: [0.5, 0.55, 0.6],
  },
  cameraLightIntensity: [0.5, 0.55, 0.6],
  fogColor: [0.1098039216, 0.1647058824, 0.3882352941],
  fogDensity: 1.5,
};

const endFadeOut = new PieceFn()
  .addSegment(0, 32, () => 0)
  .addSegment(32, 35, (t) => easeInCubic(t));

export const outroScene = createScene({
  sceneId: SCENE_OUTRO,
  shader: "outro",
  length: 64,
  name: "The End (?)",
}).addSequence([
  {
    camera: {
      position: [0, 0, -5],
      target: [0, 0, 0],
    },
    length: 4,
  },
  {
    camera: {
      position: [0, 0, -7],
      target: [0, 0, 0],
    },
    length: 4,
  },
  {
    camera: {
      position: [0, 0, -15],
      target: [0, 0, 0],
    },
    length: 4,
  },
  {
    camera: {
      position: [0, 0, -5],
      target: [0, 0, 0],
    },
    length: 4,
  },
  {
    camera: {
      position: [0, 0, -2],
      target: [0, 0, 0],
    },
    assertStart: 16,
    length: 22,
    fade: (ctx) => [
      0,
      0,
      0,
      endFadeOut.evaluate(ctx.sceneContext.sceneNowInBeats),
    ],
  },
  {
    camera: {
      position: [0, 0, -2],
      target: [0, 0, 0],
    },
    length: 42,
    fade: (ctx) => [
      0,
      0,
      0,
      endFadeOut.evaluate(ctx.sceneContext.sceneNowInBeats),
    ],
    text: [
      {
        text: "This has been a",
        position: [0.0, 0.8],
        scale: [0.0015, 0.0015],
        font: "novarese",
        align: "center",
        type: "horizontal",
      },
      {
        text: "Makaronin\nYstavaet",
        position: [-0.9, 0.5],
        scale: [0.003, 0.003],
        font: "novarese",
        align: "left",
        type: "horizontal",
        params: {
          distortion: 1.1,
          waviness: 0.2,
          color: [0.6, 0.0, 0.0],
        },
      },
      {
        text: "and",
        position: [0.0, 0.0],
        scale: [0.0015, 0.0015],
        font: "novarese",
        align: "center",
        type: "horizontal",
      },
      {
        text: "Juusto\nMakaroni\nLaatikko",
        position: [-0.9, -0.2],
        scale: [0.003, 0.003],
        font: "novarese",
        align: "left",
        type: "horizontal",
        params: {
          distortion: 1.1,
          waviness: 0.2,
          color: [0.0, 0.6, 0.0],
        },
      },
      {
        text: "production",
        position: [0.0, -0.9],
        scale: [0.0015, 0.0015],
        font: "novarese",
        align: "center",
        type: "horizontal",
      },
    ],
  },
]);
